import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Globe, Check } from "lucide-react";
import { LANGS, LANG_LABELS, useI18n } from "@/lib/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ compact = false }) {
  const { lang } = useI18n();
  const navigate = useNavigate();
  const location = useLocation();

  const switchTo = (l) => {
    localStorage.setItem("osis_lang", l);
    const parts = location.pathname.split("/").filter(Boolean);
    if (parts.length && LANGS.includes(parts[0])) parts[0] = l;
    else parts.unshift(l);
    navigate("/" + parts.join("/"));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className="flex items-center gap-2 rounded-full border border-white/15 px-3 py-2 text-sm font-mono uppercase tracking-wider text-white/80 hover:text-white hover:border-neon/60 transition-colors focus:outline-none"
      >
        <Globe className="w-4 h-4" />
        <span>{lang}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0A0A0A] border-white/10 text-white min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l}
            data-testid={`language-option-${l}`}
            onClick={() => switchTo(l)}
            className="flex items-center justify-between cursor-pointer focus:bg-white/10 focus:text-white"
          >
            <span>{LANG_LABELS[l]}</span>
            {l === lang && <Check className="w-4 h-4 text-neon" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
